import * as Localization from 'expo-localization';
import { I18n } from 'i18n-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import en from './translations/en';
import es from './translations/es';
import fr from './translations/fr';
import de from './translations/de';
import ja from './translations/ja';
import it from './translations/it';

// Create i18n instance
const i18n = new I18n({
  en,
  es,
  fr,
  de,
  ja,
  it,
});

// Helper function to safely set locale
const setSafeLocale = (locale: string | undefined | null) => {
  const safeLocale =
    locale && typeof locale === 'string' && locale.trim() ? locale : 'en';
  try {
    i18n.locale = safeLocale;
  } catch (error) {
    console.warn('Failed to set i18n locale, using default:', error);
    i18n.locale = 'en';
  }
};

// Set default locale with fallback to 'en' if Localization.getLocales is undefined
try {
  let deviceLocale: string = 'en';
  if (Localization.getLocales) {
    const locales = Localization.getLocales();
    if (
      locales &&
      locales.length > 0 &&
      typeof locales[0].languageCode === 'string'
    ) {
      deviceLocale = locales[0].languageCode || 'en';
    }
  }
  setSafeLocale(deviceLocale);
} catch (error) {
  console.warn('Failed to get device locale, using default:', error);
  setSafeLocale('en');
}

// When a value is missing from a language, it'll fallback to another language with the key present
i18n.enableFallback = true;
i18n.defaultLocale = 'en';

// Load saved language preference
const loadSavedLanguage = async () => {
  try {
    const savedLanguage = await AsyncStorage.getItem('userLanguage');
    if (savedLanguage) {
      setSafeLocale(savedLanguage);
    }
  } catch (error) {
    console.error('Failed to load language preference:', error);
  }
};

export { i18n, setSafeLocale, loadSavedLanguage };
export default i18n;
